var map = {
	"./UIBtn": 17665,
	"./UIBtn.vue": 17665,
	"./UIBtnToggle": 15690,
	"./UIBtnToggle.vue": 15690,
	"./UIButton": 82406,
	"./UIButton.vue": 82406,
	"./UICard": 98417,
	"./UICard.vue": 98417,
	"./UIChip": 38461,
	"./UIChip.vue": 38461,
	"./UIDateTable": 46915,
	"./UIDateTable.vue": 46915,
	"./UIEditDialog": 74266,
	"./UIEditDialog.vue": 74266,
	"./UIExpansionPanels": 5066,
	"./UIExpansionPanels.vue": 5066,
	"./UIListItem": 79852,
	"./UIListItem.vue": 79852,
	"./UIPagination": 68435,
	"./UIPagination.vue": 68435,
	"./UISwitch": 19478,
	"./UISwitch.vue": 19478,
	"./UITableActions": 62420,
	"./UITableActions.vue": 62420,
	"./UITabs": 54565,
	"./UITabs.vue": 54565,
	"./UITreeView": 76478,
	"./UITreeView.vue": 76478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65996;